import { motion } from 'framer-motion';

export const Screenshots = () => {
  const screenshots = [
    {
      title: 'Dashboard Principal',
      description: 'Visão geral completa das suas finanças',
      image: 'https://customer-assets.emergentagent.com/job_wallet-tracker-77/artifacts/elif53tk_Tela-1.png',
    },
    {
      title: 'Relatório de Fluxo de Caixa',
      description: 'Acompanhe receitas, despesas e custos por mês',
      image: 'https://customer-assets.emergentagent.com/job_wallet-tracker-77/artifacts/s58cpv1r_Tela-2.png',
    },
    {
      title: 'Projeção de Caixa 360',
      description: 'Integre ao saldo anterior, receitas, custos e despesas para planejar seu crescimento',
      image: 'https://customer-assets.emergentagent.com/job_multi-company-1/artifacts/caeo8ber_Projecao-de-caixa.png',
    },
    {
      title: 'Contas a Pagar',
      description: 'Controle todas as suas despesas e custos',
      image: 'https://customer-assets.emergentagent.com/job_wallet-tracker-77/artifacts/jr8b6duf_Tela-3.png',
    },
    {
      title: 'Contas a Receber',
      description: 'Gerencie todos os seus recebimentos',
      image: 'https://customer-assets.emergentagent.com/job_wallet-tracker-77/artifacts/23zha1hr_Tela-4.png',
    },
    {
      title: 'DRE - Demonstrativo de Resultado',
      description: 'Análise completa de receitas, custos e despesas',
      image: 'https://customer-assets.emergentagent.com/job_wallet-tracker-77/artifacts/1s8jtrlo_Tela-5.png',
    },
  ];

  return (
    <section id="screenshots" className="section-padding bg-white" data-testid="screenshots-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#D1FAE5] text-[#065F46] rounded-full text-sm font-semibold mb-4" data-testid="screenshots-badge">
            Interface
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4" data-testid="screenshots-title">
            Conheça o <span className="text-[#047857]">DRE+</span> por dentro
          </h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto" data-testid="screenshots-description">
            Uma interface moderna e intuitiva para você ter controle total das finanças do seu negócio.
          </p>
        </motion.div>

        {/* Screenshots Grid */}
        <div className="space-y-16" data-testid="screenshots-grid">
          {screenshots.map((screenshot, index) => (
            <motion.div
              key={screenshot.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-8 lg:gap-16 items-center`}
              data-testid={`screenshot-item-${index}`}
            >
              {/* Text Content */}
              <div className="lg:w-1/3 text-center lg:text-left">
                <h3 className="font-heading text-2xl sm:text-3xl font-bold text-[#0F172A] mb-4">
                  {screenshot.title}
                </h3>
                <p className="text-[#64748B] text-lg">
                  {screenshot.description}
                </p>
              </div>

              {/* Screenshot */}
              <div className="lg:w-2/3">
                <div className="browser-frame screenshot-card">
                  <div className="browser-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <img
                    src={screenshot.image}
                    alt={screenshot.title}
                    className="screenshot-img"
                    loading="lazy"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
